<script lang="ts">
	// The sidebar's selection checkbox (SAY-1820), styled like the rest of the
	// V2 shell instead of the browser's native control: a 16px rounded square
	// with a hairline border that fills black / white with a check when ticked.
	import CheckIcon from '@lucide/svelte/icons/check';

	let {
		checked = false,
		label,
		onchange,
		class: className = '',
		testid = 'chat-select',
	}: {
		checked?: boolean;
		label: string;
		onchange: (on: boolean) => void;
		class?: string;
		testid?: string;
	} = $props();
</script>

<button
	type="button"
	role="checkbox"
	aria-checked={checked}
	aria-label={label}
	data-testid={testid}
	onclick={(e) => {
		e.preventDefault();
		e.stopPropagation();
		onchange(!checked);
	}}
	class="flex size-4 shrink-0 items-center justify-center rounded-[5px] border transition {checked
		? 'border-gray-900 bg-gray-900 text-white dark:border-white dark:bg-white dark:text-gray-900'
		: 'border-gray-300 bg-transparent text-transparent hover:border-gray-500 dark:border-gray-600 dark:hover:border-gray-400'} {className}"
>
	<CheckIcon class="size-3" strokeWidth={3} aria-hidden="true" />
</button>
